var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 150,
    viewBox: "0 0 100 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "figma"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 125C0 111.193 11.193 100 25 100H50V125C50 138.807 38.807 150 25 150C11.193 150 0 138.807 0 125Z",
    fill: "#24CB71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.0005 0V50H75.0005C88.8075 50 100 38.807 100 25C100 11.193 88.8075 0 75.0005 0H50.0005Z",
    fill: "#FF7237"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M74.7915 100C88.5986 100 99.7915 88.8071 99.7915 75C99.7915 61.1929 88.5986 50 74.7915 50C60.9844 50 49.7915 61.1929 49.7915 75C49.7915 88.8071 60.9844 100 74.7915 100Z",
    fill: "#00B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 25C0 38.807 11.193 50 25 50H50V0H25C11.193 0 0 11.193 0 25Z",
    fill: "#FF3737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0 75C0 88.807 11.193 100 25 100H50V50H25C11.193 50 0 61.193 0 75Z",
    fill: "#874FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.724193471d9ed35bf061d57f07c909db.svg";
export { ForwardRef as ReactComponent };